@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.unread-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  background-color: var(--red-600);
  color: var(--white);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: @bold;
  padding: 0 @space-4;
  pointer-events: none;
  line-height: 1;
}
